import { Grid, Box, makeStyles, createStyles, Theme } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { Stakeholder } from '@internal/plugin-medidata-common';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: theme.shadows[2],
      borderRadius: '2px',
      overflow: 'hidden',
      position: 'relative',
      flex: '1',
      minWidth: '0px',
      wordBreak: 'break-word',
    },
    title: {
      fontWeight: 'bold',
      fontSize: 12,
    },
    content: {
      fontSize: 12,
    },
  }),
);

export const StakeholderItem = ({
  stakeholder,
}: {
  stakeholder: Stakeholder;
}) => {
  const classes = useStyles();
  return (
    <Grid item md={4} xs={8}>
      <Box className={classes.card}>
        <Box
          flexDirection="column"
          m={0.5}
          alignItems="center"
          justifyContent="center"
          word-wrap="break-word"
        >
          <Box textAlign="center">
            <span className={classes.title}>{stakeholder?.role}</span>
          </Box>
          <Box textAlign="center">
            <span className={classes.content}>
              {stakeholder?.email && (
                <Link to={`mailto:${stakeholder.email}`}>
                  {stakeholder.email}
                </Link>
              )}
            </span>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};
